<template>
  <WebPanelPage class="focus-route" title="Focus example" focus>
    <div class="flex mb5">
      <BreadcrumbNav
        :items="[
          { name: 'Home', routerLink: { name: 'home' } },
          { name: 'Focus Page' },
        ]"
      ></BreadcrumbNav>
    </div>
    <div>
      <p class="f-title">Hey I'm a focus page</p>
    </div>
  </WebPanelPage>
</template>
<script>
import BreadcrumbNav from '@sbvr/common/legacy-shared/components/BreadcrumbNav';
import WebPanelPage from '@sbvr/web-panel/WebPanelPage';

export default {
  name: 'UIModalsRoute',
  components: {
    WebPanelPage,
    BreadcrumbNav,
  },
  setup (props, { root }) {
    return {};
  },
};
</script>

<style lang="postcss" scoped>

.devices-show-route {
  @apply --container;
  padding-top: var(--spacingMd);
}
</style>
